import { STANDARD_POINTS, type PointSystem, type Score } from '../model/types.js';
import type { TrfScoreKey } from './types.js';

/** Build a point system from TRF scoring keys (TRF26 162 / XXS / BB*). */
export function pointSystemFromTrf(scoring: Partial<Record<TrfScoreKey, Score>>): PointSystem {
  const win = scoring.W ?? STANDARD_POINTS.win;
  const draw = scoring.D ?? STANDARD_POINTS.draw;
  const loss = scoring.L ?? STANDARD_POINTS.loss;
  const absent = scoring.A ?? STANDARD_POINTS.zeroBye;
  return {
    win,
    draw,
    loss,
    forfeitWin: win,
    forfeitLoss: absent,
    pab: scoring.P ?? win,
    fullBye: win,
    halfBye: draw,
    zeroBye: absent,
  };
}

/** The TRF scoring keys that differ from the defaults for a point system. */
export function trfScoringFromPointSystem(ps: PointSystem): Partial<Record<TrfScoreKey, Score>> {
  const out: Partial<Record<TrfScoreKey, Score>> = {};
  if (ps.win !== 10) out.W = ps.win;
  if (ps.draw !== 5) out.D = ps.draw;
  if (ps.loss !== 0) out.L = ps.loss;
  if (ps.zeroBye !== 0 || ps.forfeitLoss !== 0) out.A = ps.zeroBye;
  if (ps.pab !== ps.win) out.P = ps.pab;
  return out;
}
